import { render } from "./ocr_verification.html?vue&type=template&id=9b4aee74&scoped=true&external"
import script from "./ocr_verification.js?vue&type=script&lang=js&external"
export * from "./ocr_verification.js?vue&type=script&lang=js&external"

import "./OcrVerificationReport.vue?vue&type=style&index=0&id=9b4aee74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4aee74"]])

export default __exports__